import "./Services.css";
import { FaCoins, FaLockOpen } from "react-icons/fa";
import { Link } from "react-router-dom"; // ✅ IMPORTANT

export default function Services() {
  return (
    <section id="services" className="services">
      <div className="services-header">
        <h2>Our Services</h2>
        <div className="underline"></div>
      </div>

      <div className="services-container">
        
        {/* CARD 1 */}
        <div className="service-card">
          <div className="icon-box">
            <FaCoins />
          </div>
          <h3>Sell Gold</h3>
          <p>
            Convert your unused gold into instant cash with the best market price.
            Fast, secure and transparent process guaranteed.
          </p>

          {/* ✅ PAGE LINK */}
          <Link to="/sell-gold">Know More →</Link>
        </div>

        {/* CARD 2 */}
        <div className="service-card">
          <div className="icon-box">
            <FaLockOpen />
          </div>
          <h3>Release Pledge Gold</h3>
          <p>
            Release your pledged gold easily with our quick assistance and fair valuation.
          </p>

          {/* ✅ PAGE LINK */}
          <Link to="/release-gold">Know More →</Link>
        </div>

      </div>
    </section>
  );
}